import { author } from './author';
import { document } from './document';
import { documentCategory } from './document-category';
import { news } from './news';
import { newsItemCategory } from './newsitem-category';

export const entities = [
  news,
  document,
  newsItemCategory,
  documentCategory,
  author
];



// WEBPACK FOOTER //
// ./src/model/index.tsx